<template>
  <ul class="space-y-12">
    <Benefit
      v-for="perk in perks"
      :key="perk.title"
      :show-more-label="perk.details?.title"
    >
      {{ perk.title }}

      <template v-if="perk.details" #appendix>
        {{ perk.details.description }}
      </template>
    </Benefit>
  </ul>
</template>

<script setup lang="ts">
import type { MobilePlanOfferPerk } from '@backmarket/http-api/src/api-specs-partnerships/mobile-plan/types/mobile-plan-offers'
import type { ReadonlyDeep } from 'type-fest'

import Benefit from './components/Benefit/Benefit.vue'

defineProps<{
  perks: MobilePlanOfferPerk[] | readonly ReadonlyDeep<MobilePlanOfferPerk>[]
}>()
</script>
